<template >
  <b-container fluid>
    <b-row align-h="center" class="margin">
      <b-col cols="12" md="4">
          <br/><br/>
          <b-button block v-b-toggle.collapse-1 variant="secondary" size="lg" @click="showModalContrasena">Cambiar contraseña</b-button>
          <b-collapse v-if="false" id="collapse-1" class="mt-2">
            <b-card>
              <b-form-group label="Ingresa tu nueva contraseña:" label-for="input">
                <b-form-input type="password"></b-form-input>
              </b-form-group>
              <b-button variant="success">Guardar</b-button>
            </b-card>
          </b-collapse>
      </b-col>
    </b-row><br><br>
    <b-row align-h="center" class="mb-5">
      <b-col cols="12" md="4">
        <b-button block variant="secondary" size="lg" @click="cerrarSesion">Cerrar sesión</b-button>
      </b-col>
    </b-row>
    <!--modals-->
    <b-modal v-model="showModal" title="Cambio de contraseña">
      <p>{{contenidoModal}}</p>
    </b-modal>
  </b-container>
</template>

<script>
  
  export default {
    data() {
      return {
        showModal: false,
        contenidoModal:"Para cambiar su contraseña, pongase en contacto con el administrador del sistema"
      }
    },
    methods: {
      cerrarSesion(){
        this.$store.commit("clearToken");
        this.$router.push('/'+this.$route.params.municipio+'/login');
        document.location.reload(true);
      },
      showModalContrasena(){
        this.showModal= true
      }
    }
  }
</script>